import { render, staticRenderFns } from "./NewDAudioUploadEditor.vue?vue&type=template&id=03321f0a&"
import script from "./NewDAudioUploadEditor.vue?vue&type=script&lang=js&"
export * from "./NewDAudioUploadEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports